function Footer() {
    return <div className="w-full h-72 text-center">
        <div className="pt-24 text-xs">Copyright Lawrence Rogers 2023</div>
        
    </div>
}

export default Footer;